import { render, staticRenderFns } from "./DiNapoli.vue?vue&type=template&id=0146ad74&scoped=true"
import script from "./DiNapoli.vue?vue&type=script&lang=js"
export * from "./DiNapoli.vue?vue&type=script&lang=js"
import style0 from "./DiNapoli.vue?vue&type=style&index=0&id=0146ad74&prod&lang=css"
import style1 from "./DiNapoli.vue?vue&type=style&index=1&id=0146ad74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146ad74",
  null
  
)

export default component.exports